import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Inventory_NumbersClient } from 'src/api/services/generated/api-clients';

export interface IvNumberModel {
  number: string;
  selected: boolean;
}

export interface Filters {
  ivNumbers: IvNumberModel[];
  visibleColumns: string[];
  groupBy: 'category' | 'invNumber';
  globalSearch?: string;
}

@Injectable({ providedIn: 'root' })
export class FilterService {
  protected readonly invNumbersClient = inject(Inventory_NumbersClient);
  private availableIvNumbers = signal<string[]>([]);
  private readonly availableColumns = ['name', 'state', 'investments', 'sum', 'comments', 'ivNumber', 'dohs', 'dohSum'];

  public readonly idToTranslationKey: Record<string, string> = {
    name: 'Plan.Grid.Name',
    state: 'Plan.Grid.State',
    investments: 'Plan.Grid.Investments',
    sum: 'Common.Sum',
    comments: 'Plan.Grid.Comments',
    ivNumber: 'Plan.Grid.IvNumber',
    dohs: 'Plan.Grid.DirectOverheads',
    dohSum: 'Plan.Grid.DOHSum',
  };

  async init() {
    const ivNumbers = await firstValueFrom(this.invNumbersClient.getInventoryNumbers());
    this.filters.update((f) => ({
      ...f,
      ivNumbers: [
        ...(ivNumbers.data?.map((nr) => {
          return { number: nr.number, selected: true };
        }) ?? []),
      ],
    }));

    this.filters.update((f) => ({
      ...f,
      visibleColumns: [...this.availableColumns], // maybe load from user settings in future
    }));
  }

  private filters = signal<Filters>({
    ivNumbers: [],
    visibleColumns: [],
    groupBy: 'category',
    globalSearch: '',
  });

  updateFilter(partial: Partial<Filters>) {
    this.filters.update((f) => ({ ...f, ...partial }));
  }

  getAvailableColumns() {
    return this.availableColumns;
  }

  getFilters() {
    return this.filters.asReadonly();
  }

  getAvailableIvNumbers() {
    return this.availableIvNumbers();
  }
}
